export const isCrawlerBot = (userAgent) => {
    if (!userAgent) {
        return true;
    }

    const userAgentLowerCase = userAgent.toLowerCase();

    return (
        userAgentLowerCase.includes('bot') ||
        userAgentLowerCase === 'a10hm/1.0' ||
        userAgentLowerCase.includes('crawler') ||
        userAgentLowerCase.includes('sello') ||
        userAgentLowerCase === 'teracent-feed-processing' ||
        userAgentLowerCase === 'mediapartners-google' ||
        userAgentLowerCase.includes('spider')
    );
};
